<template>
  <nav class="navbar fixed-top">
    <div class="container-fluid">
      <div class="navbar-header">
        <h3 class="navbar-brand">Medical Records</h3>
        <h3 v-if="modulo == 1" class="navbar-brand">: Administración</h3>
        <h3 v-if="modulo == 2" class="navbar-brand">: Atenciones médicas</h3>
        <h3 v-if="modulo == 3" class="navbar-brand">: Financiero - Tributario</h3>
        <h3 v-if="modulo == 4" class="navbar-brand">: Dashboards</h3>
      </div>
      <button class="navbar-toggler"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar">
        <i class="material-icons">menu</i>
      </button>
      <div class="offcanvas offcanvas-end" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
        <div class="offcanvas-header">
          <table>
            <tr>
              <td>
                <h5 class="text-primary">{{ usuario }}</h5>
              </td>
            </tr>
            <tr>
              <td>
                <h5>{{ perfil }}</h5>
              </td>
            </tr>
            <tr>
              <td>
                <hr>
              </td>
            </tr>
          </table>
          <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>

        <div class="offcanvas-body">
          <ul class="navbar-nav">
            <router-link class="nav-link" to="/actualizarclave">Cambio de Clave</router-link>
            <li class="nav-link clickable" @click="logout('changeUser')">Cambio de Usuario</li>
<!--
            <router-link class="nav-link" to="/configuracion2fa">Configuración 2FA</router-link>
-->
          </ul>
        </div>

        <div class="offcanvas-body">
          <ul class="navbar-nav">
            <router-link class="nav-link" to="/consultacobertura">Consulta Cobertura</router-link>
            <router-link class="nav-link" to="/vademecum">Vademecum</router-link>
            <router-link class="nav-link" to="/calculadora">Calculadora</router-link> 

            <router-link class="nav-link" to="/imc">Cálculo de IMC</router-link>

          </ul>
        </div>

        <div class="nav-item logout-button">
          <button @click="logout('logout')">
            <i class="material-icons">power_settings_new</i>
            Cerrar Sesión
          </button>
        </div>

      </div>
    </div>
  </nav>
</template>
  
  <script>
  export default {
    name: 'Navbar',
    props: {
      usuario: String,
      perfil: String,
      modulo: Number
    },
    methods: {
      logout(action) {
        this.$emit('logout', action);
      }
    }
  };
  </script>
  <style src="@/assets/css/navbar.css" scoped></style>
  <style scoped>
    .clickable {
      cursor: pointer;
    }
  </style>